<mat-expansion-panel *ngIf="this.changeover">
    <mat-expansion-panel-header>
        <mat-panel-title>
            <span class="label">{{this.changeover!.type}}</span>
        </mat-panel-title>
        <mat-panel-description>
            <span class="label">From:</span> {{this.changeover!.from}}
            <span class="flex-spacer"></span>
            <span class="label">To:</span> {{this.changeover!.to}}
        </mat-panel-description>
    </mat-expansion-panel-header>
    <table>
        <tr>
            <th class="label">Line:</th>
            <td>{{this.changeover!.factoryName}}, {{this.changeover!.lineName}}</td>
        </tr>
        <tr>
            <th scope="header" class="label">Scheduled:</th>
            <td>{{this.scheduledTime}}</td>
        </tr>
        <tr *ngIf="this.changeover.isFinalised">
            <th scope="header" class="label">Is Finalised:</th>
            <td>yes</td>
        </tr>
    </table>
</mat-expansion-panel>